import React from "react";
import CatalogRow from "./CatalogRow";

const CatalogsList = (props) => {
  return (
    <div>
      {props.catalogIds.map((item, index) => {
        return (
          <CatalogRow {...props} key={index} index={index} catalogData={item} />
        );
      })}
    </div>
  );
};

export default CatalogsList;
